import React, { useEffect } from 'react';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';

interface PasteListenerProps {
    handler(e: ClipboardEvent): any;
}

const PasteListener: React.FC<PasteListenerProps> = ({ handler }) => {
    useEffect(() => {
        const element = document;

        const currentHandler = (e) => {
            return triggerHandler(handler, e);
        };

        element.addEventListener('paste', currentHandler);

        return () => {
            element.removeEventListener('paste', currentHandler);
        };
    }, [handler]);

    return null;
};

const PasteListenerWrapper: React.FC<PasteListenerProps> = ({ handler, ...rest }) => {
    if (handler) {
        return <PasteListener handler={handler} {...rest} />;
    }

    return null;
};

export default PasteListenerWrapper;